import { DynamicCodeLoader } from '../../utils/DynamicCodeLoader';

class NewDiscussionModuleClass {
    getDiscussionsComponent(): Promise<any>{
        return this.getDiscussionsComponentSource();
    }

    private discussionsComponentSourcePromise: Promise<typeof import('./NewDiscussionsComponent')>;
    private getDiscussionsComponentSource(){
        if(!this.discussionsComponentSourcePromise) {
            this.discussionsComponentSourcePromise = DynamicCodeLoader.importWebpackModuleWithRetry<typeof import('./NewDiscussionsComponent')>(this.constructDiscussionsComponentSourcePromise);
        }
        
        return this.discussionsComponentSourcePromise;
    }

    private constructDiscussionsComponentSourcePromise(){
        return import(/* webpackChunkName: "newDiscussionModule" */'./NewDiscussionsComponent');
    }
}

export const NewDiscussionModule = new NewDiscussionModuleClass();